var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5Bottom"},[_c('div',{class:_vm.activeTab == 1 ? 'activeTab' : '',on:{"click":function($event){return _vm.toUrl()}}},[_vm._v("首页")]),_c('div',{class:_vm.activeTab == 2 ? 'activeTab' : '',on:{"click":function($event){return _vm.toUrl(1)}}},[_vm._v("个人中心")])])
}
var staticRenderFns = []

export { render, staticRenderFns }